
import { useEffect } from "react";
import AdminSupport from "./AdminSupport";

export default function SupportChat() {

    useEffect(() => {
        if (Notification.permission !== "granted") {
            Notification.requestPermission();
        }
    }, []);
    return (
        <>
                <AdminSupport />
        </>

    );

}